import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, merge, Observable, retry, shareReplay, Subject, switchMap, tap, timer } from 'rxjs';
import { ProfileStoreService } from './profile-store-service';
import { IProfileModel } from 'app/system/mobile-models/profile-models';


@Injectable({ providedIn: 'root' })
export class ProfileApiService {
  constructor(private http: HttpClient) { }

  getProfile(): Observable<IProfileModel> {
    return this.http.get<IProfileModel>('/ctrl/ProfileJson');
  }
}

